import { render, staticRenderFns } from "./Planos.vue?vue&type=template&id=2da2ce62"
import script from "./Planos.vue?vue&type=script&lang=js"
export * from "./Planos.vue?vue&type=script&lang=js"
import style0 from "./Planos.vue?vue&type=style&index=0&id=2da2ce62&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports